module.exports = __webpack_public_path__ + "f25a09ccab16e53d9be573969cb87e61.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-ballerina-s.png
// module id = 1327
// module chunks = 0